module.exports = __webpack_public_path__ + "static/media/decathlon.baf30308.svg";